import { useState, useEffect} from "react";

// Intersection Observer
const observeConfig = { root: null, rootMargin: '0%', threshold: 0.6 };
const createObserver = callback =>
new IntersectionObserver(entries => entries.forEach(
  entry=> callback(entry.isIntersecting)),
  observeConfig);
  
export default function useOnScreen(refAll) {
  const [isOnScreen, setIsOnScreen] = useState({});
  const outEmptyEntries = entry => !!entry[1].current
  const setOnScreen = key => isIntersecting => {
    setIsOnScreen(prev => {
      return { ...prev, [key]: isIntersecting };
    });
  }
  const subscribe = ([key, ref]) => {
    const observer = createObserver(setOnScreen(key));
    observer.observe(ref.current);
    return () => {
      observer.unobserve(ref.current);
    }
  }

  useEffect(() => {
    const unsubscribers = Object.entries(refAll)
      .filter(outEmptyEntries)
      .map(subscribe);
    return () => {
      unsubscribers.forEach(unsubscribe => unsubscribe());
    };// eslint-disable-next-line
  }, [])

  return isOnScreen;
}

 
